import React from 'react';
import { IncidentTool } from '../components/IncidentTool';
import ToolHeader from '../components/ToolHeader';

export default function IncidentPage() {
  return (
    <>
      <ToolHeader toolName="Incident Management" />
      <IncidentTool />
    </>
  );
}
